import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { IUser } from '../../models/IUser';

@Injectable({
  providedIn: 'root'
})

export class PermissionGuardService {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const allowedRoles = next.data['roles'] as Array<string>;

    let user: IUser = this.authService.getLoggedInUser();

    if(user.employeePermissions.some(p => allowedRoles.includes(p.perClassType))){
      return true;
    }
    else{
      // Redirect or handle unauthorized access
      this.router.navigate(['not-allowed']);
      return false;
    }
  }

}
